<template>
  <div class="d-flex align-center number-wrap mt-n6">
    <v-btn class="mt-2" small icon @click="decrement" :disabled="vModel <= min">
      <v-icon small>mdi-minus</v-icon>
    </v-btn>

    <v-text-field
      v-model.number="localValue"
      type="number"
      dense
      hide-details
      single-line
      class="centered-input"
    ></v-text-field>

    <v-btn class="mt-2" small icon @click="increment" :disabled="vModel >= max">
      <v-icon small>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "QuantitySelector",
  props: {
    vModel: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: Infinity,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.vModel;
      },
      set(val) {
        const numeric = Math.max(this.min, Math.min(this.max, parseInt(val) || 0));
        this.$emit("input", numeric);
      },
    },
  },
  methods: {
    increment() {
      if (this.vModel < this.max) {
        this.$emit("input", this.vModel + 1);
      }
    },
    decrement() {
      if (this.vModel > this.min) {
        this.$emit("input", this.vModel - 1);
      }
    },
  },
};
</script>
<style>
.number-wrap .v-text-field__slot {
  max-width: 20px !important;
}
.text-center input {
  text-align: center;
}
.centered-input {
  max-width: 40px;
  padding: 0 !important;
}

.centered-input input {
  /* text-align: center !important; */
  padding-left: 10px !important;
}
</style>
